var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-chip-group', _vm._b({
    staticClass: "ma-n4",
    attrs: {
      "multiple": ""
    }
  }, 'v-chip-group', _vm.$attrs, false), [_vm._l(_vm.value, function (file, i) {
    return [_c('v-chip', _vm._b({
      key: i,
      staticClass: "ma-4",
      attrs: {
        "outlined": "",
        "large": "",
        "label": "",
        "close": _vm.mode == 'form'
      },
      on: {
        "click:close": function ($event) {
          return _vm.pull(file);
        }
      }
    }, 'v-chip', _vm.makeChipAttrs(file), false), [_vm.mode == 'view' ? [_c('v-icon', {
      staticClass: "mr-4",
      attrs: {
        "small": ""
      }
    }, [_vm._v(" mdi-file ")])] : _vm._e(), _c('span', [_vm._v(_vm._s(file.name))])], 2)];
  }), _vm.mode == 'form' ? [_c('v-file-btn', {
    staticClass: "ma-4 pa-0",
    attrs: {
      "tag": "v-chip",
      "outlined": "",
      "large": "",
      "label": "",
      "width": "32",
      "min-width": "32",
      "height": "32"
    },
    on: {
      "input": _vm.push
    },
    model: {
      value: _vm.temp,
      callback: function ($$v) {
        _vm.temp = $$v;
      },
      expression: "temp"
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }